import CloseIconWhite from "Assets/Icons/CloseIconWhite";
import WarningIconWhite from "Assets/Icons/WarningIconWhite";
import { SuccessfullyMessageBarDispatch } from "Context/CommonContext";
import React, { useContext, useEffect } from "react";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
const SuccessfullyMessageBar = ({ message }: any) => {
  const { screen }: any = useWindowSize();
  const successMessageInfor = useContext<any>(SuccessfullyMessageBarDispatch);
  useEffect(() => {
    setTimeout(() => {
      successMessageInfor({
        message: "",
        isShow: false,
      });
    }, 10000);
  }, []);
  return (
    <div className="addedSuccessfullyDiv">
      <div
        className={
          ["xxl", "xl", "lg"].includes(screen)
            ? "ml-6 d-flex align-items-center pt-1"
            : "ml-3 d-flex align-items-center pt-1"
        }
      >
        {["xxl", "xl", "lg"].includes(screen) ? (
          <WarningIconWhite className="d-flex pr-1" />
        ) : null}
        {message}
      </div>
      <div className="pr-4">
        <CloseIconWhite
          className="cursorHoverCSS"
          onClick={() => {
            successMessageInfor({
              message: "",
              isShow: false,
            });
          }}
        />
      </div>
    </div>
  );
};
export default SuccessfullyMessageBar;
